/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState, use } from 'react';
import { format, set } from 'date-fns';
import { Link } from '@reach/router';
import clsx from 'clsx';
import { navigate } from 'gatsby-link';
import {
	AlignJustify,
	CalendarIcon,
	CalendarRange,
	ChevronDown,
	CircleEllipsis,
	ClockIcon,
	Menu,
} from 'lucide-react';
import { useAtom } from 'jotai';
import { Button } from '../../components/atoms/button';
import GluCategories from '../../components/atoms/glu-categories';
import { PBSLink } from '../../components/atoms/link';
import GluSearchBar from '../../components/glu/atoms/glu-searchbar';
import BigScreenNav from '../../components/glu/new-glu-components/big-screen-nav';
import ArticleNav from '../../components/glu/organisms/article-nav';
import { Footer } from '../../components/glu/organisms/footer';
import {
	Sheet,
	SheetContent,
	SheetTrigger,
} from '../../components/glu/organisms/sheet-wrapper';
import StickyGluHeaderCategories from '../../components/glu/organisms/sticky-header';
import StickySearchBar from '../../components/glu/organisms/sticky-search-bar';
import { DrawerProvider } from '../../contexts/drawer-context';
import { MarketoProvider } from '../../contexts/marketo-context';
import { ScreenResizerProvider } from '../../contexts/screen-resize-context';
import { MasterLayout } from '../master';
import { buildLink } from '../../utils/locale';
import ModalWrapper from '../../components/glu/molecules/modal-wrapper';
import { UnlockAccessForm } from '../../components/glu/organisms/unlock-access-form';
import useModal from '../../hooks/modal';
import { showModalAtom } from '../../../state';
import useFindCookie from '../../hooks/useCookie';
import ScrollToTop from '../../components/glu/atoms/ScrollToTop/scrollToTop';
import GLUExitPopUp from '../../components/molecules/glu-exit-pop-up';

const NewGLULayout = ({
	children,
	nav,
	className,
	locale = 'en',
	rating,
	articleData,
	bannerData,
	weeklyWebinar,
}) => (
	<ScreenResizerProvider>
		<DrawerProvider>
			<MarketoProvider>
				<MasterLayout>
					<NewLayout
						nav={nav}
						weeklyWebinar={weeklyWebinar}
						className={className}
						locale={locale}
						rating={rating}
						articleData={articleData}
						bannerData={bannerData}
					>
						{children}
					</NewLayout>
				</MasterLayout>
			</MarketoProvider>
		</DrawerProvider>
	</ScreenResizerProvider>
);

NewGLULayout.defaultProps = {
	className: '',
	locale: 'en',
	rating: '',
	articleData: null,
	bannerData: null,
};

NewGLULayout.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	locale: PropTypes.string,
	rating: PropTypes.string,
	articleData: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string,
		image: PropTypes.string,
	}),
	bannerData: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string,
		image: PropTypes.string,
	}),
};

export { NewGLULayout };

const NewLayout = ({
	children,
	locale,
	rating,
	articleData,
	bannerData,
	nav,
	weeklyWebinar,
}) => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(true);
	const [isMobile, setIsMobile] = useState(false);
	const [consentResponse, setConsentResponse] = React.useState(false);
	const [clearConsent, setClearConsent] = React.useState(false);
	const ref = useRef();
	const { isModalOpen, setModalOpen } = useModal(ref);
	const [showModal, setShowModalAtom] = useAtom(showModalAtom);
	const { hasCookie, setHasCookie } = useFindCookie({
		name: 'elearningContent',
	});
	const { hasCookie: clearCookies } = useFindCookie({
		name: 'start__c',
	});
	React.useEffect(() => {
		if ((consentResponse && clearConsent) || (hasCookie && clearCookies)) {
			setHasCookie(true);
		}
	}, [clearConsent, consentResponse, hasCookie, clearCookies, setHasCookie]);
	useEffect(() => {
		if (showModal) {
			setModalOpen(true);
		} else {
			setModalOpen(false);
		}
	}, [showModal, setModalOpen]);
	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth < 1024);
			if (window.innerWidth < 1024) {
				setIsSidebarOpen(false);
			}
		};

		// Check on mount and on resize
		checkIfMobile();
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);

	const toggleSidebar = () => {
		if (isMobile) {
			setIsSidebarOpen(!isSidebarOpen);
		} else {
			setIsSidebarOpen(!isSidebarOpen);
		}
	};
	const [isScrolled, setIsScrolled] = useState(false);
	const windowScrollRef = React.useRef(null);
	useEffect(() => {
		const handleScroll = () => {
			if (windowScrollRef.current) {
				const { scrollTop } = windowScrollRef.current;
				setIsScrolled(scrollTop > 20);
			}
		};

		const scrollElement = windowScrollRef.current;
		if (scrollElement) {
			scrollElement.addEventListener('scroll', handleScroll);
		}

		return () => {
			if (scrollElement) {
				scrollElement.removeEventListener('scroll', handleScroll);
			}
		};
	}, []);

	const isBrowser = typeof window !== 'undefined';
	useEffect(() => {
		if (isBrowser) {
			if (window.location.href.includes('#upcomingWebinars')) {
				setTimeout(() => {
					window.document
						.getElementById('upcomingWebinars')
						.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
							inline: 'nearest',
						});
				}, 100);
			}
			if (window.location.href.includes('#webcastHR')) {
				setTimeout(() => {
					window.document.getElementById('webcastHR').scrollIntoView({
						behavior: 'smooth',
						block: 'start',
						inline: 'nearest',
					});
				}, 100);
			}
			if (window.location.href.includes('#webcastHS')) {
				setTimeout(() => {
					window.document.getElementById('webcastHS').scrollIntoView({
						behavior: 'smooth',
						block: 'start',
						inline: 'nearest',
					});
				}, 100);
			}
		}
	}, [isBrowser]);

	return (
		<div className="flex h-screen bg-white">
			<GLUExitPopUp locale={locale} />
			{/* Mobile Sidebar (Sheet) */}
			{isMobile && (
				<Sheet open={isSidebarOpen} onOpenChange={setIsSidebarOpen}>
					<SheetContent side="left" className="w-full p-0 bg-white">
						<div className="h-full overflow-y-auto bg-brand-pale-400 transform transition-all duration-300 ease-in-out">
							<SidebarContent
								isMobile={isMobile}
								nav={nav}
								setIsSidebarOpen={setIsSidebarOpen}
								weeklyWebinar={weeklyWebinar}
							/>
						</div>
					</SheetContent>
				</Sheet>
			)}

			{/* Desktop Sidebar */}
			{!isMobile && (
				<div className="h-full bg-brand-pale-400 border-none transition-all duration-300 ease-in-out w-72">
					<div className="h-full overflow-y-auto py-5">
						<SidebarContent
							collapsed={false}
							setIsSidebarOpen={setIsSidebarOpen}
							isMobile={isMobile}
							nav={nav}
							weeklyWebinar={weeklyWebinar}
						/>
					</div>
				</div>
			)}

			{/* Main Content Area */}
			<div className="flex-1 flex flex-col overflow-hidden relative ">
				{locale === 'en' &&
					articleData?.length > 0 &&
					articleData !== undefined && (
						<ArticleNav
							articleData={articleData}
							locale={locale}
							bannerData={bannerData}
						/>
					)}
				{/* Sticky Header */}
				<header
					className={`bg-white border-none sticky top-0 z-10 lg:px-6 ${
						isScrolled ? 'lg:shadow-lg' : 'shadow-none'
					}`}
				>
					<div className="flex flex-col items-center justify-between py-1 w-full">
						<div className="flex items-center w-full justify-between">
							{/* Logo and Desktop Categories */}
							<div className="flex items-center lg:w-full lg:justify-between">
								{/* Logo */}
								<div className="w-24 glumd:w-40 flex-none">
									<PBSLink
										to="/elearning/"
										variant="Unset"
										className="block"
									>
										<img
											src="https://www.datocms-assets.com/64336/1684148941-glu.svg"
											alt="glu logo"
											className="object-cover w-full h-full"
										/>
									</PBSLink>
								</div>

								{/* Desktop Categories - Only visible on desktop */}
								{!isMobile && (
									<div className="ml-4">
										<StickyGluHeaderCategories
											isScrolled={isScrolled}
										/>
									</div>
								)}
							</div>

							<div className="flex items-center">
								{/* Search Bar - Only visible on mobile devices */}
								{isMobile && (
									<StickySearchBar
										siteTitle="E-learning"
										mobileOnlyHamburger
										locale={locale}
										gluLayout
									/>
								)}

								{/* Mobile Menu Button - Only visible on mobile and positioned on the right */}
								{isMobile && (
									<Sheet>
										<SheetTrigger asChild>
											<Button
												variant="Unset"
												aria-label="menu-icon"
												size="Tiny"
												className="!m-0 !p-0"
												onClick={toggleSidebar}
											>
												<Menu className="h-12 w-12 -mt-2 mx-2" />
											</Button>
										</SheetTrigger>
									</Sheet>
								)}
							</div>
						</div>
					</div>
				</header>
				{/* Categories on mobile - only visible on mobile */}
				{isMobile && (
					<div className="w-full max-m-w-screen mx-auto bg-white z-10">
						<StickyGluHeaderCategories isScrolled={isScrolled} />
					</div>
				)}
				<div>
					{isModalOpen && (
						<ModalWrapper>
							<div
								className="relative m-auto mx-8 overflow-auto  md:rounded-sm rounded-none w-full  z-50 sm:w-3/4 lg:w-1/2 xl:w-1/3 md:mx-0"
								ref={ref}
								id="modal-open"
							>
								<button
									title="Close Peninsula Now Modal"
									type="button"
									onClick={() => setShowModalAtom(false)}
									className="absolute flex top-[5px] text-2xl bg-tranparent font-bold right-[1px] opacity-100 border-2 border-black h-9 w-9 items-center justify-center rounded-full text-black"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										x="0px"
										y="0px"
										width="20"
										height="20"
										viewBox="0 0 50 50"
										className="fill-current text-brand-pale-200 font-bold"
									>
										<path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z" />
									</svg>
								</button>
								<UnlockAccessForm
									pageUrl={
										typeof window !== 'undefined'
											? window.location.href
											: ''
									}
									locale={locale}
									setClearConsent={setClearConsent}
									setConsentResponse={setConsentResponse}
									setModalOpen={setModalOpen}
									className="!rounded-none"
									headerContent="Your expert e-learning content is waiting for you"
									subTextContent="Whether you're a client or not, access your e-learning sessions by sharing your details:"
								/>
							</div>
						</ModalWrapper>
					)}
				</div>
				{/* ScrollToTop Button */}
				<ScrollToTop scrollRef={windowScrollRef} />
				{/* Main Content */}
				<main
					ref={windowScrollRef}
					className="flex-1 overflow-y-auto py-5 md:p-6 bg-white z-20 relative "
				>
					{/* Desktop Search - Only visible on desktop */}
					{!isMobile && (
						<div className="mb-6 px-4">
							<StickySearchBar
								siteTitle="E-learning"
								mobileOnlyHamburger
								locale={locale}
								gluLayout
							/>
						</div>
					)}
					{children}
					<Footer locale={locale} rating={rating} />
				</main>
			</div>
		</div>
	);
};

const SidebarContent = ({
	collapsed,
	setIsSidebarOpen,
	isMobile,
	nav,
	weeklyWebinar,
	locale,
}) => {
	const pbsWebinar = false;

	// Ensure weeklyWebinar.startTime is valid
	const startTime = weeklyWebinar?.startTime
		? new Date(weeklyWebinar.startTime)
		: null;
	const time = startTime
		? `${format(startTime, `h:mm${pbsWebinar ? 'a' : ''}`)} ${
				weeklyWebinar.timeEnd ? `- ${weeklyWebinar.timeEnd}` : ''
		  }`
		: 'Time not available';

	// Split nav into main categories and additional categories
	const mainCategories = nav.slice(0, 5);
	const additionalCategories = nav.slice(5);

	const [openMoreDropdown, setOpenMoreDropdown] = useState(false);

	return (
		<div
			className={clsx(
				'flex flex-col h-full py-10 md:py-0 transform transition-all duration-700 ease-in-out ',
				collapsed ? 'w-12' : 'w-full'
			)}
		>
			{/* Navigation Links */}
			<nav className="flex-1 overflow-y-auto carousel-hide-scrollbar">
				<ul
					className={clsx(
						'space-y-2 flex flex-col gap-3 w-full',
						collapsed ? 'p-2' : 'p-1'
					)}
				>
					{/* Render main categories */}
					{mainCategories.map((category) => (
						<NavLinkGlu
							key={category.title}
							category={category}
							collapsed={collapsed}
							isMobile={isMobile}
							setIsSidebarOpen={setIsSidebarOpen}
						/>
					))}

					{/* Render "More GLU" dropdown if there are additional categories */}
					{additionalCategories.length > 0 && (
						<li className="flex flex-col items-center transform transition-all duration-700 ease-in-out gap-5 w-full">
							<div
								className="flex gap-2 items-center w-full cursor-pointer"
								onClick={() => {
									setOpenMoreDropdown(!openMoreDropdown);
									setIsSidebarOpen(true);
								}}
								tabIndex={0}
								role="button"
								aria-expanded={openMoreDropdown}
								aria-controls="more-glu-dropdown"
							>
								<CircleEllipsis className="w-7 h-7 -mt-1 ml-1" />
								{!collapsed && (
									<div className="justify-between flex w-full mx-2">
										More GLU
										<ChevronDown
											className={`ml-20 transition-transform ${
												openMoreDropdown
													? 'rotate-180'
													: 'rotate-0'
											}`}
											size={16}
										/>
									</div>
								)}
							</div>

							{/* Dropdown for additional categories */}
							{!collapsed && openMoreDropdown && (
								<div className="bg-brand-pale-400 w-full z-10 transition-all duration-300">
									{additionalCategories.map((sub) => (
										<Link
											key={sub.title}
											to={sub.link}
											className="flex items-center gap-2 px-4 py-2 hover:bg-grey-400/20"
										>
											<img
												src={sub.icon.url}
												alt={`${sub.title} Icon`}
												className="w-6 h-6"
											/>
											{sub.title}
										</Link>
									))}
								</div>
							)}
						</li>
					)}
				</ul>
				{!collapsed && (
					<>
						<div className="h-0.5 ml-4 w-[85%] mt-5 items-center dark:bg-brand-blue-500 rounded-l-md rounded-r-md" />
						<div className="flex flex-col items-center justify-center p-5">
							<p className="font-bold text-xl text-brand-blue-500">
								Level up your skills at our{' '}
								<span className="text-brand-red-400"> L</span>
								ive{' '}
								<span className="text-brand-red-400"> W</span>
								eekly{' '}
								<span className="text-brand-red-400"> W</span>
								ebinars
							</p>
						</div>
						<div className="pl-5 pr-5">
							<p className="mb-2 text-md flex">
								<div>
									<CalendarRange
										className="w-[22px] text-blue-300 inline-block mr-4"
										aria-hidden
									/>
								</div>
								<div>{weeklyWebinar.title}</div>
							</p>
							<p className="mb-4 text-md">
								<CalendarIcon
									className="w-[22px] text-blue-300 inline-block mr-4"
									aria-hidden
								/>
								{weeklyWebinar.dateAndTime}
							</p>
							<p className="mb-4 text-md">
								<ClockIcon
									className="w-[22px] text-blue-300 inline-block mr-4"
									aria-hidden
								/>
								{time}
							</p>
							<div>
								<PBSLink
									to={`${
										pbsWebinar
											? buildLink(locale, '/webinars/')
											: buildLink(
													locale,
													'/elearning/webinar/'
											  )
									}${weeklyWebinar.slug}`}
									className="text-center !text-sm"
									size="Small"
									target="_blank"
								>
									Register your place
								</PBSLink>
							</div>
						</div>
						<div className="h-0.5 ml-4 w-[85%] mt-5 items-center dark:bg-brand-blue-500 rounded-l-md rounded-r-md" />
					</>
				)}
			</nav>
		</div>
	);
};
const NavLinkGlu = ({ category, collapsed, isMobile, setIsSidebarOpen }) => {
	const [openDropdown, setOpenDropdown] = useState(null);
	const toggleDropdown = (categoryTitle) => {
		setOpenDropdown((prev) =>
			prev === categoryTitle ? null : categoryTitle
		);
	};
	const Component = 'div';

	useEffect(() => {
		if (collapsed && !isMobile) {
			setOpenDropdown((prev) => !prev);
		}
	}, [collapsed, isMobile]);
	return (
		<li
			key={category.title}
			className="flex flex-col items-center transform transition-all duration-700 ease-in-out gap-5 w-full"
		>
			<PBSLink
				to={category.link || ''}
				variant="Unset"
				className="flex gap-2 items-center w-full"
				aria-expanded={openDropdown === category.title}
				aria-controls={`dropdown-${category.title}`}
				onClick={() => {
					if (category.treeChildren) {
						if (!isMobile) {
							setIsSidebarOpen(true);

							toggleDropdown(category.title);
						} else {
							toggleDropdown(category.title);
						}
					}
				}}
			>
				<img
					src={category.icon.url}
					alt={`${category.title} Icon`}
					className="w-8 h-8 -mt-1"
					width="32"
					height="32"
					loading="lazy"
				/>
				{!collapsed && (
					<div className="justify-between flex w-full mx-2">
						{category.title}

						{category.treeChildren.length > 0 && (
							<ChevronDown
								className={`ml-20 transition-transform ${
									openDropdown === category.title
										? 'rotate-180'
										: 'rotate-0'
								}`}
								size={16}
							/>
						)}
					</div>
				)}
			</PBSLink>

			{category.treeChildren.length > 0 &&
				openDropdown === category.title && (
					<Component className="bg-brand-pale-400 w-full z-10 transition-all duration-300">
						{category.treeChildren.map((sub) => (
							<Link
								key={sub.title}
								to={sub.link}
								className="flex items-center gap-2 px-4 py-2 hover:bg-grey-400/20"
								onClick={() => {
									if (isMobile) {
										setIsSidebarOpen(false);
									}
								}}
							>
								<img
									src={sub?.icon?.url}
									alt={sub.title}
									className="w-6 h-6"
									loading="lazy"
								/>

								{sub.title}
							</Link>
						))}
					</Component>
				)}
		</li>
	);
};
